import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../common/Modal/Modal';
import RadioButton from '../common/RadioButton/RadioButton';

class IfbModal extends React.PureComponent {
	handleModalRadioButtonChange = (e) => {
		this.props.changeIFBbytesPerSample(parseInt(e.target.value));
	};

	radioBtn1Text = (
		<span>
			Change the audio to be <span className="font-weight-bold">
				higher
			</span>{' '}
			in pitch and play <span className="font-weight-bold">faster</span>
		</span>
	);

	radioBtn2Text = (
		<span>
			Change the audio to be <span className="font-weight-bold">
				lower
			</span>{' '}
			in pitch and play <span className="font-weight-bold">slower</span>
		</span>
	);

	render() {
		return (
			<Modal
				uniqueId="ifb-modal"
				hideHeader={true}
				containerClass="modal-dialog-centered premium-logout-modal"
				bodyClass="premium-modal-body"
				buttons={[{ name: 'Save', className: 'premium-logout-btn-confirm' }]}
			>
				<div className="logout-content">
					<i className="material-icons logout-warning-icon">audiotrack</i>
					<p style={{ fontSize: '1rem', color: '#ccc', marginBottom: '20px' }}>
						In case you experience issues with IFB audio, please choose from below:
					</p>
					<div style={{ textAlign: 'left', width: '100%', padding: '0 20px' }}>
						<RadioButton
							radioGroupName="ifb-options"
							radioId="option1"
							radioValue="4"
							changeHandler={this.handleModalRadioButtonChange}
							labelText={this.radioBtn1Text}
						/>
						<RadioButton
							radioGroupName="ifb-options"
							radioId="option2"
							radioValue="2"
							changeHandler={this.handleModalRadioButtonChange}
							labelText={this.radioBtn2Text}
						/>
					</div>
				</div>
			</Modal>
		);
	}
}

IfbModal.propTypes = {
	changeIFBbytesPerSample: PropTypes.func.isRequired
};

export default IfbModal;
